import BlockyLightText from "components/custom-texts/blocky-light-text.tsx";
import { sparketLightGray } from "utils/constants.ts";

interface PaymentMethod {
  type: 'ACH' | 'CARD';
  bankAccountId?: string;
  inovioUserPaymentMethodId?: string;
  bankName?: string;
  last4?: string;
}

interface PaymentNoteProps {
  processing?: boolean;
  paymentMethod?: PaymentMethod;
  actionType: 'deposit' | 'withdraw';
  customMessage?: string;
}

const PaymentNote = ({ 
  processing, 
  paymentMethod, 
  actionType, 
  customMessage 
}: PaymentNoteProps) => {
  const getPaymentMessage = () => {
    if (customMessage) {
      return customMessage;
    }

    if (!paymentMethod) {
      return "";
    }

    const verb = actionType === 'deposit' ? 'transferred from' : 'sent to';
    const action = actionType === 'deposit' ? 'will be' : 'will be';

    if (paymentMethod.type === 'ACH') {
      const bankInfo = paymentMethod.bankName && paymentMethod.last4 
        ? `${paymentMethod.bankName} account ••••${paymentMethod.last4}`
        : 'your selected bank account';
      return `Funds ${action} ${verb} your ${bankInfo}`;
    } else if (paymentMethod.type === 'CARD') {
      if (paymentMethod.inovioUserPaymentMethodId === 'NEW') {
        return "You will be navigated to the payment page";
      } else if (paymentMethod.last4) {
        return actionType === 'deposit' 
          ? `Your account ••••${paymentMethod.last4} will be charged by Sparket.`
          : `Funds will be sent to your card ••••${paymentMethod.last4}`;
      }
    }

    return "";
  };

  const paymentMessage = getPaymentMessage();

  return (
    <div className="d-flex flex-column align-items-center mt-2" style={{ width: "100%" }}>
      <div
        className="d-flex flex-column align-items-center"
        style={{
          color: sparketLightGray,
          width: "100%",
          textAlign: "center"
        }}
      >
        {processing ? (
          <div>
            <BlockyLightText className="text-center m-2" style={{ color: "white", fontSize: "1.2rem" }}>
              Processing...
            </BlockyLightText>
          </div>
        ) : (
          paymentMessage && (
            <div className="text-center" style={{ maxWidth: "500px" }}>
              <BlockyLightText style={{ 
                fontSize: "14px", 
                lineHeight: "1.4",
                textAlign: "justify"
              }}>
                {paymentMessage}
              </BlockyLightText>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default PaymentNote; 